import { useEffect } from "react";

export function LogoMask(wpContent) {
  useEffect(() => {
    // *** Le setup *__*
    const altLogo = document.getElementById("logo-dark");
    const logoMask = document.getElementById("logo-mask");
    const mainSections = [...document.querySelectorAll("main > section")];
    const altSections = document.querySelectorAll(".page-yellow");
    function isYellow(section) {
      return section.classList.contains("page-yellow");
    }
    console.log(
      "There are currently " +
        mainSections.length +
        " sections of which " +
        altSections.length +
        " are yellow sections."
    );

    if (!altLogo || !logoMask || !altSections.length) return;

    // Get logo bounds
    function getLogoBounds() {
      const rect = altLogo.getBoundingClientRect();
      return {
        top: rect.top,
        bottom: rect.bottom,
        height: rect.height,
      };
    }

    // Check if sections are alt or not
    function isPrevAlt(section) {
      const prevSection = section.previousElementSibling;
      return prevSection && prevSection.classList.contains("page-yellow");
    }
    function isNextAlt(section) {
      const nextSection = section.nextElementSibling;
      return nextSection && nextSection.classList.contains("page-yellow");
    }

    // Update function: will update the alt logo's mask position based on which section is intersecting.
    function update(section) {
      // Update logo bounds, because it's got position:sticky
      const { top, bottom, height } = getLogoBounds();
      // Get alt section bounds
      const rect = section.getBoundingClientRect();

      // Overlap calculations
      const overlapTop = Math.max(rect.top, top);
      const overlapBottom = Math.min(rect.bottom, bottom);
      const overlap = Math.max(0, overlapBottom - overlapTop);

      if (overlap === 0) return;

      const progress = overlap / height;
      const clamped = Math.min(1, progress);

      let yAtt = height * (1 - clamped);
      if (isYellow(section)) {
        if (isPrevAlt(section)) {
          logoMask.setAttribute("y", 0);
        } else {
          yAtt *= 1;
        }
      }
      if (rect.bottom <= bottom && !isNextAlt(section)) {
        yAtt *= -1;
      }
      if (!isYellow(section)) {
        return (yAtt = height);
      }
      logoMask.setAttribute("y", yAtt);
    }

    // Create the observer / Check which section is within the viewport
    const options = {
      threshold: 0.1,
    };
    function callback(entries) {
      entries.forEach((entry) => {
        let section = entry.target;
        if (entry.isIntersecting) {
          update(section);
        }
      });
    }
    let observer = new IntersectionObserver(callback, options);
    mainSections.forEach((section) => {
      observer.observe(section);
    });

    // handle scroll
    function handleScroll() {
      mainSections.forEach(update);
    }
    document.addEventListener("scroll", () => handleScroll());

    //React clean up
    return () => {
      observer.disconnect();
      document.removeEventListener("scroll", handleScroll());
    };
  }, [wpContent]);
}
